import axios from "axios"
import { POSTS_LIMIT } from "@/constants/postsFeed.js"

export const groups = () => axios.get("/api/v2/groups")

export const userGroups = () => axios.get("/api/v3/account/groups")

export const userMembershipRequests = () => axios.get("/api/v2/group_membership_requests")

export const activityFeedPosts = ({ cursor, limit }) =>
  axios.get("/api/v2/recent_posts", {
    params: { cursor, limit: limit || POSTS_LIMIT }
  })

export const members = ({ id, page }) =>
  axios.get(`/api/v2/groups/${id}/members`, {
    params: {
      page
    }
  })

export const collageMembers = ({ groupKeys }) =>
  axios.get("/api/v2/groups/collage_members", {
    params: {
      group_keys: groupKeys
    }
  })

export const adminMembers = ({ id, page }) =>
  axios.get(`/api/v2/groups/${id}/admin_members`, {
    params: {
      page
    }
  })

export const newMembers = ({ id, page }) =>
  axios.get(`/api/v2/groups/${id}/new_members`, {
    params: {
      page
    }
  })

export const recentPosts = ({ key, cursor }) =>
  axios.get(`/api/v2/walls/${key}/recent_posts`, {
    params: {
      cursor,
      limit: POSTS_LIMIT
    }
  })

export const hottestPosts = ({ key, page }) =>
  axios.get(`/api/v2/walls/${key}/hottest_posts`, {
    params: {
      page,
      limit: POSTS_LIMIT
    }
  })

export const join = (key) => axios.post(`/api/v2/groups/${key}/membership`)

export const leave = (key) => axios.delete(`/api/v2/groups/${key}/membership`)

export const cancelRequest = (key) => axios.delete(`/api/v2/groups/${key}/membership_request`)

export const getMembershipRequests = ({ key, page }) =>
  axios.get(`/api/v2/groups/${key}/membership_requests`, {
    params: {
      page
    }
  })

export const declineMembershipRequest = ({ key, userId }) => axios.delete(`/api/v2/groups/${key}/membership_requests/${userId}`)

export const acceptMembershipRequests = ({ key, ids }) =>
  axios.post(`/api/v2/groups/${key}/membership_requests/approve`, {
    user_ids: ids
  })
